// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27BQA","fullView":"styles_fullView__43CI7"};